import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'vodOutputs',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: false,
  emptyMessage: "You don't have vod outputs, visit the vod output section to create one.",
  fields: [
    {
      attributeName: 'vod',
      label: 'Vod',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canFilter:true,
      canEdit: true,
      canCreate: true,
      canOpen: true,
      helpText: 'Name of the vod.',
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canFilter:true,
      canEdit: true,
      canCreate: true,
      canOpen: true,
      helpText: 'Name of the output per vod.',
    },
    {
      attributeName: 'outputFile',
      label: 'File',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canFilter:true,
      canEdit: true,
      canCreate: true,
      canOpen: true,
      helpText: 'VoD output file URL.',
    },
  ],
};
